import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../constants/firebaseModular';
import { Button } from '.';
import * as Sentry from '@sentry/browser';

export const RequestPasswordReset = (props: { email: string }) => {
  const onClick = () => {
    const validEmail = (email: string) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
    };

    if (!validEmail(props.email)) {
      alert('Please enter a valid email address');
      return;
    }
    sendPasswordResetEmail(auth, props.email)
      .then(() => {
        alert('Password reset email sent');
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('Error sending password reset email: ', error);
        alert(`Error sending password reset email: ${error.message}`);
      });
  };

  return <Button id="request-reset" type="button" textContent="Reset Password" onClick={onClick} />;
};
